<template>
  <b-card>
    <b-card-title class="d-flex justify-content-between align-items-center">
      <b-button
        class="btn-icon rounded-circle"
        variant="flat-primary"
        @click="$router.push({
          path: `/users/${user.id}?externalId=${user.external_id}`
        })"
      >
        <feather-icon
          icon="UserIcon"
        />
      </b-button>
      <h4 class="text-center">
        User
      </h4>
      <b-button
        class="btn-icon rounded-circle"
        variant="flat-primary"
        @click="$router.push({
          path: `/users/${user.id}?externalId=${user.external_id}`,
          query: { 'active-tab' :'wallet' }
        })"
      >
        <feather-icon
          icon="BriefcaseIcon"
        />
      </b-button>
    </b-card-title>
    <hr>
    <b-row
      class="pt-2"
    >
      <b-col
        v-for="(item, idx) in pickFrom"
        :key="idx"
        md="12"
        class="mb-1"
      >
        <span class="font-weight-bold">{{ item.label }}: </span> {{ item.key(user) ? item.key(user) : '_' }}
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard, BCardTitle, BRow, BCol, BButton,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardTitle,
    BRow,
    BCol,
    BButton,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const pickFrom = [
      {
        key: el => `${el?.first_name} ${el?.last_name}`,
        label: 'Name',
      },
      {
        key: el => el?.phone_number,
        label: 'Phone Number',
      },
      {
        key: el => el?.email,
        label: 'Email',
      },
    ]

    return {
      pickFrom,
    }
  },
}
</script>
